import { Button } from '@seen/ui'
import { IconAlertCircle, IconArrowLeft } from '@tabler/icons-react'
import type { JSX } from 'react'
import { useNavigate } from 'react-router'
import { Card } from '#src/components/core/Card.tsx'

interface ParticipantNotFoundProps {
  participantId: string
}

export function ParticipantNotFound({
  participantId: _,
}: ParticipantNotFoundProps): JSX.Element {
  const navigate = useNavigate()

  return (
    <div className="flex h-full w-full items-center justify-center">
      <Card className="flex h-40 w-2/3 flex-col items-center justify-center">
        <h2 className="flex items-center gap-2 text-lg font-semibold">
          <IconAlertCircle className="size-6" /> Participant Not Found
        </h2>
        <div className="mt-4">
          <Button onClick={() => navigate(-1)} variant="outline">
            <IconArrowLeft className="mr-2 size-4" />
            Go Back
          </Button>
        </div>
      </Card>
    </div>
  )
}
